import { createContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { setMonitoredContext } from '@BUP/services/monitor.js'
import { addTrackedUserToGroup, setTrackedUserData } from '@BUP/services/tracker.js'
import { useGetCurrent } from '@BUP/hooks/Current/useGetCurrent'
import BupLoading from '@BUP/components/Loading/Main'
import ErrorMessage from '@BUP/components/Error/Message'
import LocaleProvider from '@BUP/contexts/locale-provider'

export const OrganizationContext = createContext()

export const OrganizationContextProvider = ({ children }) => {
  const { t } = useTranslation()

  const {
    currentData: organization,
    isLoadingCurrent: loadingOrganization,
    errorCurrent: organizationError
  } = useGetCurrent('current-enrollment/organization', 3)

  const {
    currentData: locale,
    isLoadingCurrent: loadingLocale,
    errorCurrent: errorLocale
  } = useGetCurrent('current-organization/location', 3)

  useEffect(() => {
    if (!organization) return

    setTrackedUserData({
      organizationId: organization.id,
      organization: organization.name
    })

    addTrackedUserToGroup('school', organization.id, {
      $name: organization.name,
      name: organization.name
    })

    setMonitoredContext('organization', {
      organizationId: organization.id,
      organizationName: organization.name
    })
  }, [organization, organization?.id]) // <-- Avoids unnecessary executions

  if (loadingOrganization || loadingLocale) return <BupLoading />

  if (organizationError || errorLocale) {
    return (
      <ErrorMessage
        message={t('common.resources.organizations.actions.read.failure', {
          context: 'support'
        })}
        withSignOut
      />
    )
  }

  if (!organization || !locale) return null

  return (
    <OrganizationContext.Provider value={organization}>
      <LocaleProvider locale={locale.locale}>
        {children}
      </LocaleProvider>
    </OrganizationContext.Provider>
  )
}
